@if (selectLastChild$ | async) {}
<div
  class="flex align-items-center justify-content-center top-header-tab relative"
  [ngClass]="{ 'active-tab': active() }"
  #headerTab
>
  <div class="active-left"></div>
  <a
    class="inner-tab-container"
    [routerLink]="!tabData().children.length ? tabData().routeUrl : null"
  >
    <div
      class="inner-tab flex align-items-center gap-1"
      (click)="goTo(dropdown)"
      (keydown.enter)="goTo(dropdown)"
    >
      <span class="webkit-box-one-line body-medium-medium">{{
        tabData().name
      }}</span>
      @if (tabData().children.length) {
        <em class="ml-auto icon-caret-down"></em>
      }
    </div>
    <p-select
      #dropdown
      styleClass="hidden-dropdown"
      [appendTo]="headerTab"
      [options]="tabData().children"
      [overlayOptions]="{ styleClass: 'dropdown-overlay-tab-position' }"
      [(ngModel)]="activeDropDownMenu"
      optionLabel="name"
      placeholder=""
      (onChange)="selectChild($event)"
    />
  </a>
  <div class="active-right"></div>
</div>
